import type {
  GetRsvpDataBody,
  GetRsvpDataResponse,
} from '@bridebook/web/pages/api/for/website/[websiteId]/rsvp/guest/get';
import type {
  SaveGuestRsvpRequestBody,
  SaveGuestRsvpResponse,
} from '@bridebook/web/pages/api/for/website/[websiteId]/rsvp/guest/save';
import { HttpStatusCode } from '@bridebook/toolbox/src/api/http-status';
import { fetchy, FetchyError } from '@bridebook/web/lib/fetchy';

export const fetchGuestRsvp: (
  websiteId: string,
  params: GetRsvpDataBody,
) => Promise<{
  data: GetRsvpDataResponse;
  httpStatus: number;
}> = async (websiteId, params) => {
  try {
    const response = await fetchy().post(
      '/api/for/website/[websiteId]/rsvp/guest/get',
      { websiteId },
      params,
    );

    return {
      data: response,
      httpStatus: HttpStatusCode.OK,
    };
  } catch (error) {
    return {
      data: (error as FetchyError).response ?? error.message,
      httpStatus: (error as FetchyError).code ?? HttpStatusCode.InternalServerError,
    };
  }
};

export const updateGuestRsvp: (
  websiteId: string,
  params: {
    id: SaveGuestRsvpRequestBody['id'];
    invitation: SaveGuestRsvpRequestBody['invitation'];
  },
) => Promise<{
  data: SaveGuestRsvpResponse;
  httpStatus: number;
}> = async (websiteId, params) => {
  try {
    const response = await fetchy().post(
      '/api/for/website/[websiteId]/rsvp/guest/save',
      { websiteId },
      params,
    );

    return {
      data: response,
      httpStatus: HttpStatusCode.OK,
    };
  } catch (error) {
    return {
      data: (error as FetchyError).response ?? error.message,
      httpStatus: (error as FetchyError).code ?? HttpStatusCode.InternalServerError,
    };
  }
};
